var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 33C8.15789 33 1 25.8421 1 17C1 8.15789 8.15789 1 17 1C25.8421 1 33 8.15789 33 17C33 25.8421 25.8421 33 17 33Z",
    stroke: "#619428",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49463 22.3895C10.0104 23.4 11.8631 23.9895 13.8841 23.9895C20.3683 23.9895 24.0736 18.5158 23.8209 13.5474C24.4946 13.0421 25.0841 12.4526 25.5894 11.6947C24.9999 11.9474 24.3262 12.2 23.5683 12.2842C24.3262 11.8631 24.8315 11.1895 25.0841 10.3474C24.4104 10.7684 23.6525 11.021 22.8946 11.1895C22.2209 10.5158 21.3788 10.0947 20.3683 10.0947C18.0946 10.0947 16.4104 12.2 16.9157 14.3895C13.9683 14.221 11.442 12.8737 9.67358 10.7684C8.74726 12.3684 9.16831 14.3895 10.7683 15.4842C10.1788 15.4842 9.67358 15.3158 9.16831 15.0631C9.16831 16.6631 10.263 18.1789 11.9473 18.5158C11.442 18.6842 10.9367 18.6842 10.3473 18.6C10.7683 20.0316 12.1157 21.0421 13.6315 21.0421C12.1999 22.0526 10.3473 22.5579 8.49463 22.3895Z",
    fill: "#619428"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterOrange);
export default __webpack_public_path__ + "static/media/twitter_orange.39f8db1d66774c1334cc792de23524af.svg";
export { ForwardRef as ReactComponent };